import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import pdf from '../../assets/images/pdf.jpg'
import {base64MimeType,downloadBase64} from '../../utils/tools'

const styles = {
  card: {
    maxWidth: 345,
  },
  media: {
    width: "100%",
    height: "auto"
  },
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ImgMediaCard extends React.Component {
  state = {
    open: false,
    numPages: null,
    pageNumber: 1,
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    let mimeType = base64MimeType(this.props.image)
    return (
      <Card className={this.props.classes.card}>
          <CardMedia
            component="img"
            className={this.props.classes.media}
            height="140"
            image={mimeType === "application/pdf" ? pdf : this.props.image}
            title={this.props.title}
          />
        {!this.props.hideButtons && (
            <CardActions>
                <Button size="small" color="primary" onClick={() => this.props.onDelete("Suppression", "Êtes-vous sûr de vouloir supprimer ce document ?", this.props.deleteCallback)}>
                    Supprimer
                </Button>
                <Button size="small" color="primary" onClick={() => {mimeType === "application/pdf" ? downloadBase64(this.props.image) : this.handleClickOpen()}} >
                    Ouvrir
                </Button>
            </CardActions>
        )}
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={this.props.classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
            <CardMedia
            component="img"
            width="100%"
            height="auto"
            image={this.props.image}
            title={this.props.title}
          />
        </Dialog>
      </Card>
    );
  }
}

ImgMediaCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ImgMediaCard);



// WEBPACK FOOTER //
// ./src/component/utils/ImgMediaCard.js